import { Button, ButtonProps, Icon } from "@chakra-ui/react";
import useCustomToast from "../../lib/useCustomToast";
import { copyUrl } from "../../utils/helperFunction";
import { RiShareLine } from "@remixicon/react";

interface Props extends ButtonProps {
  btnText?: string;
  productId?: any;
  storeId?: any;
}

export const ButtonCopyUrl = ({
  btnText = "Salin Link",
  productId,
  storeId,
  ...rest
}: Props) => {
  const toast = useCustomToast();

  const copy = async () => {
    let linkToCopy = "";
    if (storeId && productId) {
      linkToCopy = `${process.env.REACT_APP_FRONTEND_URL}/product/${storeId}/${productId}`;
    } else {
      linkToCopy = `${process.env.REACT_APP_FRONTEND_URL}/reseller/${storeId}`;
    }

    const copyLink = await copyUrl(linkToCopy);
    if (copyLink === 1) {
      toast({
        title: `Link berhasil disalin`,
        status: "success",
      });
    } else {
      toast({
        title: `Link gagal disalin`,
      });
    }
  };

  return (
    <Button
      colorScheme="red"
      variant={"outline"}
      onClick={copy}
      leftIcon={<Icon as={RiShareLine} />}
      {...rest}
    >
      {btnText}
    </Button>
  );
};
